.modal {
  max-width: 750px !important;
}

.cards {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
